Date.prototype.addDays = /** @param {number} days */function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};
Object.size = /** @param {Object} obj */function(obj) {
  var size = 0,
    key;
  for (key in obj) {
    if (obj.hasOwnProperty(key)) size++;
  }
  return size;
};
const knocking = {
  variantState: {
    regular: "regular",
    soldout: "soldout",
    preorder: "preorder",
    extendedOffer: "extendedoffer",
    holidayShipping: "holidayshipping",
  },
  knockingLogActive: false,
  log: function(...args) {
    if (!this.knockingLogActive) {
      return;
    }
  },
  /**
   * @param {number} days
   */
  addDays: function(days) {
    const daysToAddInMs = days * 86400000;
    const datePlusDays = new Date(new Date().getTime() + daysToAddInMs);
    return datePlusDays;
  },
  /**
   * @param {number} days
   */
  addBusinessDays: function(days) {
    let date = new Date();
    for (let addedDays = 0; addedDays < days;) {
      date.setDate(date.getDate() + 1);
      let dayOfWeek = date.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        addedDays++;
      }
    }
    return date;
  },
  openCart: function() {
    messenger.emmit(messenger.topics.OPEN_CART);
  },
  /**
   * @param {Cart} cart
   */
  buildCart: function(cart) {
    // console.log("building cart in library: ", cart);
    if (!cart) {
      console.error("no cart passed to build cart");
      messenger.emmit(messenger.topics.UPDATE_CART_BUBBLE, 0);
      return;
    }
    // console.log('building cart', cart);
    messenger.emmit(messenger.topics.BUILD_CART, cart);
    messenger.emmit(messenger.topics.CHECK_LIMITS, cart);
    messenger.emmit(messenger.topics.UPDATE_CART_BUBBLE, cart.item_count);
  },
  /**
   * @param {number} itemCount
   */
  updateCartBubble(itemCount) {
    if (isNaN(itemCount)) {
      console.log("no item count passed to update cart bubble");
      return;
    }
    messenger.emmit(messenger.topics.UPDATE_CART_BUBBLE, itemCount);
  },
  /**
   * @param {Cart} cart
   * @returns {void}
   * */
  checkLimits(cart) {
    if (!cart) {
      console.error("no cart passed to check limits");
      return;
    }
    messenger.emmit(messenger.topics.CHECK_LIMITS, cart);
  },
  /**
   * @param {Limit} limitObj
   * @returns {Array<any>}
   * */
  objectToArrayOfObjects: function(limitObj) {
    let arr = [];
    for (const [key, value] of Object.entries(limitObj)) {
      /**
       * @type {Object.<string, any>}
       */
      let tempObj = {};
      tempObj[key] = value;
      arr.push(tempObj);
    }
    return arr;
  },
  async getCart() {
    console.log("fetching cart");
    const cart = await fetch("/cart.js");
    return cart.json();
  },
  async clearCart() {
    try {
      const res = await fetch(`${routes.cart_clear_url}`, {
        ...fetchConfig(),
      });
      /**
       * @type {Cart}
       */
      const cart = await res.json();
      this.buildCart(cart);
      return cart;
    } catch (error) {
      console.log(error);
    }
  },
  // order limits


  /**
   * Calculates the actual limit status in the cart.
   * @param {Cart | null} cart - Cart object.
  * @param {number | null} diffQuantity - Difference in quantity.
  * @param {string} productId - Product ID.
  * @param {string} rawVendor - Vendor name.
  * @returns {Promise<Limit | null>} - Product limit object.
  * */
  async returnLimitStatus(cart, diffQuantity, productId, rawVendor = "") {
    const vendor = rawVendor.toString().trim();
    // TO DO: we probably don't need diffQuantity here
    if (cart === null) {
      cart = await store.getCart();
    }
    if (!cart) {
      console.error("cannot get cart in returnLimitStatus");
      return null;
    }
    console.log('checking limit status for product: ', productId);
    productId = productId.toString();
    let item = cart.items.find(
      (item) => item.product_id.toString() === productId
    );
    console.log('item found in cart: ', item);
    if (item && item.limit) {
      return item.limit;
    } else {
      let limit = this.getProductLimit(productId);
      console.log('product limit found: ', limit);
      if (limit) {
        const productLimit = {
          limitReached: false,
          remainingQty: limit,
          type: "product",
          quantity: limit,
        };
        console.log('returning product limit: ', productLimit);
        return productLimit;
      }
    }
    // Check brand limit
    // console.log(`finding item with vendor: ${vendor} in cart: `, cart);
    item = cart.items.find(
      (item) =>
        item.vendor === vendor && item.limit && item.limit.type === "brand"
    );
    if (item && item.limit) {
      // console.log(
      //   'brand limit item found in cart, returning limit status: ',
      //   item.limit
      // );
      return item.limit;
    } else {
      // console.log('no item in cart yet, getting limit by vendor');
      const limit = this.getBrandLimit(vendor);
      // console.log('brand limit: ', limit);
      if (limit) {
        const brandLimit = {
          limitReached: false,
          remainingQty: limit,
          type: "brand",
          quantity: limit,
        };
        console.log('returning brand limit: ', brandLimit);
        return brandLimit;
      }
    }

    if (window.enableGlobalProductLimit) {
      const limit = window.globalProductLimit;
      const globalLimit = {
        limitReached: false,
        remainingQty: limit,
        type: "product",
        quantity: limit,
      }
      return globalLimit;
    }
    return null;
  },

    /**
     * @param {string} vendor - Vendor name.
     * @returns {number | null} - Brand limit.
     * */
    getBrandLimit(vendor) {
    const decodedVendor = decodeURIComponent(vendor);
    if (window.brandLimits[decodedVendor]) {
      return window.brandLimits[decodedVendor];
    }
    return null;
  },
  /**
   * @param {string} id - Product ID.
   * @returns {number | null} - Product limit.
   **/
  getProductLimit(id) {
    if (window.productLimits[id]) {
      return window.productLimits[id];
    }
    return null;
  },
  // calcRemainingQty(limitType, diffQuantity, id, cart = null) {
  //   if (cart === null) {
  //     cart = this.getCart();
  //   }
  //   if (limitType === 'product') {
  //     const item = cart.items.find((item) => item.product_id === id);
  //     return item.limit.remainingQty;
  //   } else if (limitType === 'brand') {
  //     const item = cart.items.find((item) => item.vendor === id);
  //     return item.limit.remainingQty;
  //   }
  // },
  async checkIfBrandLimitIsReached(vendor, limit, qty, line) {
    const decodedVendor = decodeURIComponent(vendor);
    const newQty = parseInt(qty);
    // console.log(
    //   `check if brand-order limit for vendor "${decodedVendor}" of ${limit} is reached by updating line ${line} to ${qty}`
    // );
    const cart = await this.getCart();
    let itemsOfVendorInCart = 0;
    for (let i = 0; i < cart.items.length; i++) {
      const item = cart.items[i];
      const lineIndex = i + 1;
      // console.log(`item vendor: ${item.vendor}, vendor: ${decodedVendor}, line: ${line}`);
      if (
        item.vendor === decodedVendor &&
        !window.productLimits[item.product_id]
      ) {
        itemsOfVendorInCart += item.quantity;
        // console.log(`already in cart: ${itemsOfVendorInCart}`);
      }
    }
    if (itemsOfVendorInCart + newQty > limit) {
      return { hasLimit: true, alreadyInCart: itemsOfVendorInCart };
    }
    return { hasLimit: false, alreadyInCart: itemsOfVendorInCart };
  },
  /**
   * @param {string} id
   * @param {number} limit
   * @param {string} qty
   */
  async checkIfProductLimitIsReached(id, limit, qty) {
    const newQty = parseInt(qty);
    // console.log(
    //   `check if product-order limit for id "${id}" of ${limit} is reached by adding ${qty} items`
    // );
    const cart = await this.getCart();
    let itemsOfProductInCart = 0;
    for (let i = 0; i < cart.items.length; i++) {
      const item = cart.items[i];
      // const lineIndex = i + 1;
      if (item.product_id === parseInt(id)) {
        // console.log(
        //   `product_id: ${item.product_id} qty: ${newQty} in cart: ${item.quantity} limit: ${limit}`
        // );
        itemsOfProductInCart += item.quantity;
      }
    }
    if (itemsOfProductInCart + newQty > limit) {
      return { hasLimit: true, alreadyInCart: itemsOfProductInCart };
    }
    return { hasLimit: false, alreadyInCart: itemsOfProductInCart };
  },
  alertProductLimitReached(productName, limit) {
    // console.log(`alertProductLimitReached: ${productName} ${limit}`);
    // alert(
    //   `You can only put ${limit} ${decodeURIComponent(
    //     productName
    //   )} in you cart!`
    // );
  },
  /**
   * @param {string} price
   */
  formatToDollarCurrencyString(price) {
    if (!price) {
      return "$";
    }
    let slicedString = price.toString().slice(-2);
    let dollars = price.toString().slice(0, -2);
    let cents = price.toString().slice(-2);
    return `$${dollars}.${cents}`;
  },
  /**
   * @param {string} shippingTagTrimmed
   * @param {boolean} [includeYear]
   */
  calculateShippingDate(shippingTagTrimmed, includeYear = true) {
    if (shippingTagTrimmed && shippingTagTrimmed.includes("businessdays")) {
      const shippingInBusinessDays = shippingTagTrimmed.replace(
        "businessdays",
        ""
      );
      return knocking.addBusinessDays(parseInt(shippingInBusinessDays));
    } else if (shippingTagTrimmed.includes("days")) {
      const shippingInDays = shippingTagTrimmed.replace("days", "");
      return knocking.addDays(parseInt(shippingInDays));
    } else {
      const dateArray = shippingTagTrimmed.split("-");
      const year = parseInt(dateArray[0]);
      const month = parseInt(dateArray[1]) - 1; // month is zero based!
      const dayDate = parseInt(dateArray[2]);
      if (!includeYear) {
        return new Date(year, month);
      }
      return new Date(year, month, dayDate);
    }
  },
  /**
   * @param {Date} dateObject
   * @param {boolean} [includeYear]
   */
  formatDateObjectToKnockingDateString(dateObject, includeYear = true) {
    // console.log('formatDateObjectToKnockingDateString: ', {dateObject});
    const dateString = dateObject.toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      year: includeYear ? "numeric" : undefined,
    });
    // console.log('dateString: ', dateString);
    return dateString;
  },
  /**
   * @param {Array<string>} tags
   */
  getTagShippingDate(tags) {
    // console.log('getTagShippingDate: ', tags);
    if (tags) {
      for (let i = 0; i < tags.length; i++) {
        const tag = tags[i];
        if (tag.includes("ships_by-")) {
          if (tag.includes(":")) {
            const shippingRange = tag.replace("ships_by-", "").split(":");
            const shippingDateRange = [];
            for (let i = 0; i < shippingRange.length; i++) {
              const shippingDate =
                knocking.formatDateObjectToKnockingDateString(
                  knocking.calculateShippingDate(shippingRange[i], false),
                  false
                );
              // const shipsByDate = knocking.formatDateObjectToKnockingDateString(shippingDate);
              shippingDateRange.push(shippingDate);
            }
            return shippingDateRange.join(" - ");
          }
          return knocking.calculateShippingDate(tag.replace("ships_by-", ""));
        }
      }
    }
    return knocking.calculateShippingDate(defaultShippingDate);
  },
  getUniqueId() {
    return Math.floor(Math.random() * Date.now());
  },
  /**
   * @param {string} key
   * @param {any} value
   * @param {number} expDays
   */
  setCookie(key, value, expDays) {
    const d = new Date();
    d.setTime(d.getTime() + expDays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie = key + "=" + value + ";" + expires + ";path=/";
  },
  /**
   * @param {string} key
   */
  getCookie(key) {
    const name = key + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        // console.log('found cookie: ', c);
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  showBlur() {
    if (!document.querySelector("#blur-overlay")) return;
    document.querySelector("#blur-overlay").style.display = "block";
  },
  hideBlur() {
    if (!document.querySelector("#blur-overlay")) return;
    document.querySelector("#blur-overlay").style.display = "none";
  },
  disableScroll() {
    const scrollTop = document.documentElement.scrollTop;
    window.onscroll = function() {
      window.scrollTo(0, scrollTop);
    };
  },
  enableScroll() {
    window.onscroll = function() { };
  },
  calculateDiscountPercent(variant) {
    // console.log('calc discount: ', variant)
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const discount =
        ((variant.compare_at_price - variant.price) * 100) /
        variant.compare_at_price;
      return Math.round(discount);
    }
    return "Exclusive Offer";
  },
};

// console.log('knocking library loaded');
window.knockingLibraryLoaded = true;

//# sourceMappingURL=knocking-library.js.map
